import { useMutation } from "react-query";
import { updateZip } from "components/photography/lib/photoData";

export const useUpdateZip = () => {
    return useMutation(({ photoWipKey, shotKey, zipFile, imageViewCode }) => {
        const formData = new FormData();
        formData.append("file", zipFile);
        formData.append("imageView", imageViewCode);
        formData.append("awaitThumbnailCreation", true);
        formData.append("imageType", '1');

        return updateZip(photoWipKey, shotKey, formData);
    });
};
